module.exports = __webpack_public_path__ + "static/img/2.404de80.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/sp/2.png
// module id = WLxk
// module chunks = 0